import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './CountdownTimer.css';

function CountdownTimer({ targetDate }) {
    const { t } = useTranslation();
    const calculateTimeLeft = () => {
        const difference = +new Date(targetDate) - +new Date();
        let timeLeft = {};
        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60),
            };
        }
        return timeLeft;
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);
        return () => clearInterval(timer);
    }, [targetDate]);

    if (!Object.keys(timeLeft).length) {
        return <div className="countdown-ended">{t('common.countdown.expired')}</div>;
    }

    const segments = [
        { label: t('common.countdown.days'), value: timeLeft.days },
        { label: t('common.countdown.hours'), value: timeLeft.hours },
        { label: t('common.countdown.min'), value: timeLeft.minutes },
        { label: t('common.countdown.sec'), value: timeLeft.seconds },
    ];

    return (
        <div className="timer-wrapper">
            <span className="timer-label">{t('common.countdown.title')}</span>
            <div className="countdown-timer">
                {segments.map((s, idx) => (
                    <div key={idx} className="timer-segment">
                        <span className="segment-value">{String(s.value).padStart(2, '0')}</span>
                        <span className="segment-label">{s.label}</span>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default CountdownTimer;
